import { ShareLinkIcon } from "@flat-ui";
import { commonStrings } from "@assets/common-strings";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { MenuItemOption } from "@components/common/mobile/list-item-card-mobile";
import {
  HoloBuilderMuiIcon,
  ViewerMuiIcon,
} from "@pages/projects/projects-utils";
import { SdbProject } from "@custom-types/project-types";
import {
  getOpenProjectHref,
  trackOpenProject,
  trackShareProject,
} from "@utils/project-utils";
import { useAppSelector } from "@store/store-helper";
import { defaultProjectLaunchTargetSelector } from "@store/sdb-company/sdb-company-selector";
import { useSphereDialog } from "@components/common/dialog/sphere-dialog-provider";
import {
  SHARE_PROJECT_DIALOG_PROVIDER_PROPS,
  ShareProject,
} from "@components/project/share-project";
import { ProjectLaunchTarget } from "@custom-types/sdb-company-types";

export function useProjectMenuOptionsMobile(): MenuItemOption<SdbProject>[] {
  const { trackEvent, trackAsyncEvent } = useTrackEvent();
  const { createDialog } = useSphereDialog();

  const projectLaunchSettings = useAppSelector(
    defaultProjectLaunchTargetSelector
  );

  const menuOptions: MenuItemOption<SdbProject>[] = [
    {
      label: commonStrings.SPHERE_XG,
      Icon: ViewerMuiIcon,
      onSelect: async (project) => {
        await trackOpenProject({
          trackAsyncEvent,
          openFrom: "projects-menu-option-mobile",
          numberOfMembers: project.members.length,
          openTarget: ProjectLaunchTarget.sphereViewer,
          ...project,
        });
      },
      getHrefUrl: (project) => {
        return getOpenProjectHref({
          projectId: project.id,
          openTarget: ProjectLaunchTarget.sphereViewer,
        });
      },
    },
  ];

  if (projectLaunchSettings.shouldShowOpenInWebEditorBtn) {
    menuOptions.push({
      label: commonStrings.HOLOBUILDER_PRODUCT_NAME,
      Icon: HoloBuilderMuiIcon,
      onSelect: async (project) => {
        await trackOpenProject({
          trackAsyncEvent,
          openFrom: "projects-menu-option-mobile",
          numberOfMembers: project.members.length,
          openTarget: ProjectLaunchTarget.webEditor,
          ...project,
        });
      },
      getHrefUrl: (project) => {
        return getOpenProjectHref({
          projectId: project.id,
          openTarget: ProjectLaunchTarget.webEditor,
        });
      },
    });
  }

  menuOptions.push({
    label: "Share",
    Icon: ShareLinkIcon,
    onSelect: (project) => {
      trackShareProject({
        ...project,
        eventLocation: "mobile-menu",
        trackEvent,
      });

      void createDialog(
        SHARE_PROJECT_DIALOG_PROVIDER_PROPS,
        <ShareProject projectId={project.id} />
      );
    },
  });

  return menuOptions;
}
